import React from 'react';
import './ui.css';

/**
 * PageHeader — standardized page heading.
 * Props: eyebrow, title, subtitle, actions (node)
 */
export default function PageHeader({ eyebrow, title, subtitle, actions, children }) {
  return (
    <header className="ui-page-header">
      <div className="ui-page-header__text">
        {eyebrow && <p className="ui-page-header__eyebrow">{eyebrow}</p>}
        <h1 className="ui-page-header__title">{title}</h1>
        {subtitle && <p className="ui-page-header__subtitle">{subtitle}</p>}
        {children}
      </div>
      {actions && <div className="ui-page-header__actions">{actions}</div>}
    </header>
  );
}
